import React, { useEffect, useState } from "react";

import {
  Link,
  NavLink,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
  useNavigation,
  useResolvedPath,
} from "react-router-dom";
import { useDisclosure } from "@mantine/hooks";
import {
  AppShell,
  Group,
  Burger,
  Skeleton,
  ScrollArea,
  Text,
  Anchor,
  Input,
  UnstyledButton,
} from "@mantine/core";
import _breadcrumb from "./_breadcrumb";
import { AuthProvider } from "../../helper/IAuthProvider";
import { SkeletonBase } from "./_skeleton";
import { IconLogout, IconSearch } from "@tabler/icons-react";
import classes from "../../_style/NavbarSegmented.module.css";
import { _sideNavData } from "../../../_setup/navdata/_sideNavData";
import { LinksGroup } from "./NavbarLinksGroup";
import { isNullOrEmpty } from "../../extension/StringExtension";
import { searchSideNavData } from "../../helper/FunctionHelper";
import { LinksGroupProps } from "../../model/_base/LinksGroupProps";
import TokenService from "../../../api/login/token.service";
import { NotificationExtension } from "../../extension/NotificationExtension";
//context
import imageLogo from "../../../assets/images/logoE-sign.png";

export const LayoutAnonymus = () => {
  // #region state

  const location = useLocation();
  const navigate = useNavigate();
  const [loadingSkeleton, setLoadingSkeleton] = useState(true);
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const [sideNavs, setSideNavs] = useState<LinksGroupProps[]>([]);

  //#endregion

  //#region  auth
  //#endregion
  useEffect(() => {
    setLoadingSkeleton(false);
    window.scrollTo(0, 0);
    return () => {
      setLoadingSkeleton(true);
    };
  }, [location.pathname, navigate]);

  //

  // matine

  const renderLogo = () => (
    <div className="e-folder">
      <div className="e-folder-name">
        <img alt="" style={{ width: 70, height: 70 }} src={imageLogo} />
      </div>
    </div>
  );
  // search menu

  return (
    <>
      <AppShell
        header={{ height: 50 }}
        navbar={{
          width: 300,
          breakpoint: "sm",
          collapsed: {
            mobile: !mobileOpened,
            desktop: true,
          },
        }}
        padding="md"
      >
        <AppShell.Header>
          <Group px="md">
            <Burger
              opened={desktopOpened}
              onClick={toggleDesktop}
              visibleFrom="md"
              size="sm"
            />
            {renderLogo()}
          </Group>
        </AppShell.Header>
        <AppShell.Navbar py="md" px={4}>
          {/* <UnstyledButton className={classes.control}>Home</UnstyledButton>
        <UnstyledButton className={classes.control}>Blog</UnstyledButton>
        <UnstyledButton className={classes.control}>Contacts</UnstyledButton>
        <UnstyledButton className={classes.control}>Support</UnstyledButton> */}
        </AppShell.Navbar>
        <AppShell.Main component={"main"}>
          {loadingSkeleton ? (
            <SkeletonBase visible={loadingSkeleton}></SkeletonBase>
          ) : (
            <>
              <Outlet />
            </>
          )}
        </AppShell.Main>
      </AppShell>
    </>
  );
};
